import styled from "styled-components";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import { useContext, useEffect } from "react";
import Context from "../../../../Context";
import PullToRefresh from "react-simple-pull-to-refresh";
import LoadingSection from "../../../helperComponents/LoadingSection";
import SectionsForManagement from "./sectionsForManagement/SectionsForManagement";
import SectionsForEmployees from "./sectionsForEmployees/SectionsForEmployees";
import NomenclatureOfEmployee from "../nomenclature/NomenclatureOfEmployee";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  width: 100%;
  /* margin-top: 50px; */

  @media (max-width: 900px) {
    gap: 50px;
  }
`;

const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 50px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 40px;
    margin-top: -20px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  gap: 30px;
  flex: 1;

  @media (max-width: 900px) {
    gap: 15px;
    margin-top: 15px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 300;
  color: var(--accent);
  opacity: 0.8;
`;
const List = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const MobileHomeHeader = styled.div`
  display: none;

  @media (max-width: 900px) {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

const MobileRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export default function HomePage() {
  const { updateLoggedInUser, loggedInUser, isMobile } = useContext(Context);

  // useEffect(() => {
  //   loadStuff();
  // }, []);

  if (!loggedInUser)
    return (
      <Container>
        <LoadingSection />
      </Container>
    );

  let core = (
    <LoggedInBoilerplate
      titleLine1={"Tableau"}
      titleLine2={"De Bord"}
      showFooter={true}
    >
      {getComp()}
    </LoggedInBoilerplate>
  );

  if (!isMobile) return core;

  return (
    <PermissionGuard permissionName={"dashboardPermissions"} action={"VIEW"}>
      {core}
    </PermissionGuard>
  );
  // return (
  //   <PullToRefresh
  //     // refreshingContent={false}
  //     onRefresh={loadStuff}
  //   >
  //     {core}
  //   </PullToRefresh>
  // );

  function getComp() {
    return <SectionsForManagement />;
    if (loggedInUser.accountType == "MANAGEMENT")
      return <SectionsForManagement />;
    if (loggedInUser.accountType == "EMPLOYEE") return <SectionsForEmployees />;
  }

  // async function loadStuff(skipCache) {
  //   await updateLoggedInUser();
  // }
}
